import React, { Component } from 'react'
import PostIframe from './util/PostIframe'
import uniqueId from 'lodash/uniqueId'
import { parse, format } from 'url'

export default class Widget extends Component {

  widgetId = uniqueId()

  state = {
    widgetHeight: 600
  }

  componentDidMount() {
    window.addEventListener("message", this.recievePostMessage)    
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.recievePostMessage)
  }

  recievePostMessage = event => {
    const { data } = event
    if (data.type === 'SIDX_HEIGHT_CHANGE' && data.reportHeight === this.widgetId) {
      if (this.state.widgetHeight !== data.payload.height) {
        this.setState({ widgetHeight: data.payload.height })
      }
    }
  }

  getWidgetUrl() {
    const { src, dynamicHeight } = this.props
    const url = `${process.env.SEARCH_URL}/app/widget/${src}`
    const parsed = parse(url)
    if (dynamicHeight) {
      const param = `reportHeight=${this.widgetId}`
      parsed.search = parsed.search ? `${parsed.search}&${param}` : `?${param}`
    }
    return format(parsed)
  }

  getContentWindow() {
    return this.iframe && this.iframe.contentWindow
  }

  render() {
    const { params, ...props } = this.props
    const { widgetHeight } = this.state
    delete props.dynamicHeight
    if (params) {
      return (
        <PostIframe ref={el => this.iframe = el && el.iframe} frameBorder="0" height={widgetHeight} {...props} src={this.getWidgetUrl()} params={params} />
      )
    } else {
      return (
        <iframe ref={el => this.iframe = el} frameBorder="0" height={widgetHeight} {...props} src={this.getWidgetUrl()} />
      )
    }
  }
}



// WEBPACK FOOTER //
// client/components/Widget.js